<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page"> <div class="bb-page-shell">
<!-- HEADER -->
<div class="bb-page-header">
  <div class="bb-inline-flex bb-items-center bb-gap-16">
    <div class="bb-client-avatar">
      <img src="/assets/emploees.png" [alt]="'Company Logo' | transloco" class="bb-w-100 bb-h-100 bb-rounded-full">
    </div>

    <div class="bb-page-title-block">
      <span class="bb-eyebrow">{{ 'employee details' | transloco }}</span>
      <h2 class="bb-page-title">{{name}}</h2>
      <p class="bb-page-subtitle">{{ 'job title' | transloco }}: {{job_title}}</p>
      <p class="bb-page-subtitle">{{ 'salary' | transloco }}: {{salary}}</p>
    </div>
  </div>

  <div class="bb-header-actions noPrint">
    <button class="bb-btn bb-btn-secondary" onclick="window.print();">
      {{ 'Print' | transloco }}
    </button>

    <button class="bb-btn bb-btn-primary" (click)="paySalary()">
      {{ 'pay salary this month' | transloco }} {{salaryMonth}}
    </button>
  </div>
</div>

<!-- FILTERS -->
<div class="bb-filter-card noPrint">
  <div class="bb-form-grid">
    <!-- Filter By Day -->
    <div class="bb-field">
      <label class="bb-label">
        {{ 'Filter by day' | transloco }}
      </label>
      <div class="bb-select-wrap">
        <select class="bb-select" [(ngModel)]="filteredDate" (change)="filterByDate()">
          <option *ngFor="let date of uniqueDates" [value]="date">
            {{ date }}
          </option>
        </select>
      </div>
    </div>

    <!-- Filter By Month -->
    <div class="bb-field">
      <label class="bb-label">
        {{ 'Filter by Month' | transloco }}
      </label>
      <div class="bb-select-wrap">
        <select class="bb-select" [(ngModel)]="filteredMonth" (change)="filterByMonth()">
          <option *ngFor="let month of uniqueMonths" [value]="month">
            {{ month }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<!-- LOANS -->
<div class="bb-card bb-p-20 bb-mb-16">
  <div class="bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap bb-mb-16">
    <h5 class="bb-m-0 bb-text-navy bb-font-bold">{{ 'Loans' | transloco }}</h5>
    <button class="bb-btn bb-btn-danger bb-btn-sm" (click)="addLoan()">
      {{ 'Add loan' | transloco }}
    </button>
  </div>

  <div class="bb-grid bb-gap-12">
    <div *ngFor="let loan of loans" class="bb-cart-item bb-text-danger">
      {{ loan.amount }} - {{ loan.note }}
    </div>
  </div>
</div>

<!-- BONUSES -->
<div class="bb-card bb-p-20 bb-mb-16">
  <div class="bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap bb-mb-16">
    <h5 class="bb-m-0 bb-text-navy bb-font-bold">{{ 'Bonuses' | transloco }}</h5>
    <button class="bb-btn bb-btn-primary bb-btn-sm" (click)="addBonuses()">
      {{ 'Add Bonuse' | transloco }}
    </button>
  </div>

  <div class="bb-grid bb-gap-12">
    <div *ngFor="let bonuse of bonuses" class="bb-cart-item bb-text-success">
      {{ bonuse.amount }} - {{ bonuse.note }}
    </div>
  </div>
</div>

<!-- DEDUCTIONS -->
<div class="bb-card bb-p-20">
  <div class="bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap bb-mb-16">
    <h5 class="bb-m-0 bb-text-navy bb-font-bold">{{ 'Deductions' | transloco }}</h5>
    <button class="bb-btn bb-btn-secondary bb-btn-sm" (click)="addDeduction()">
      {{ 'Add deduction' | transloco }}
    </button>
  </div>

  <div class="bb-grid bb-gap-12">
    <div *ngFor="let deduction of deductions" class="bb-cart-item bb-text-danger">
      {{ deduction.amount }} - {{ deduction.note }}
    </div>
  </div>
</div>
</div> </section> <!-- POPUP --> <div *ngIf="showFinPopUp" class="bb-modal-backdrop popup"> <div class="bb-modal-card popup-box">
<div class="bb-modal-header">
  <h4>{{ 'Add Transaction' | transloco }}</h4>
  <button class="bb-modal-close" type="button" (click)="close()">×</button>
</div>

<div class="bb-grid bb-gap-12">
  <input class="bb-input" type="text" [(ngModel)]="amount" placeholder="{{ 'amount' | transloco }}">
  <input class="bb-input" type="text" [(ngModel)]="note" placeholder="{{ 'note' | transloco }}">

  <div class="bb-modal-actions">
    <button class="bb-btn bb-btn-primary" (click)="onSubmit()">
      {{ "Submit" | transloco }}
    </button>

    <button class="bb-btn bb-btn-secondary" (click)="close()">
      {{ "close" | transloco }}
    </button>
  </div>
</div>
</div> </div>